/**
 * This method runs only in development & test mode (production mode is disabled).
 *
 * NOTE: This is method does not support buffering in order to enable troubleshooting on development machine.
 * @param data
 * @returns
 */
export var sendEventToConsole = function sendEventToConsole(data) {
  // Console output is only used during development on development machine
  if (window.ENVIRONMENT === 'production') {
    return;
  }
  // eslint-disable-next-line no-console
  console.log(data);
};